import React, { useEffect, useState } from 'react';
import { Box, FormField, Header, Multiselect, MultiselectProps } from '@amzn/awsui-components-core';
import { OptionDefinition } from '@amzn/awsui-components-core/internal/components/option/interfaces';
import { UserRoles } from '@amzn/awscat-pattern-library-service-model';
import {
  NonCancelableCustomEvent,
  NonCancelableEventHandler,
} from '@amzn/awsui-components-core/internal/events';
import constants from '../../../common/constants';

class UserRoleMultiSelectProps {
  // @ts-expect-error TS2564 - strict migration
  userRoles: Set<UserRoles>;
  // @ts-expect-error TS2564 - strict migration
  onSelectedRolesUpdated: (selectedRoles: Set<UserRoles>) => void;
}

export function UserRoleMultiSelect(props: UserRoleMultiSelectProps) {
  const options: OptionDefinition[] = [
    { value: UserRoles.Admin, label: constants.USER_ROLES_TYPE_ADMIN },
    { value: UserRoles.TechWriter, label: constants.USER_ROLES_TYPE_TECHWRITER },
    { value: UserRoles.Publisher, label: constants.USER_ROLES_TYPE_PUBLISHER },
  ];

  const [selectedOptions, setSelectedOptions] = useState<readonly OptionDefinition[]>(
    options.filter((o) => props.userRoles.has(o.value as UserRoles)),
  );

  useEffect(() => {
    setSelectedOptions(Array.from(props.userRoles).map((r) => ({ value: r, label: r })));
  }, [props.userRoles]);

  const handleSelectionChange = (
    event: NonCancelableCustomEvent<MultiselectProps.MultiselectChangeDetail>,
  ) => {
    setSelectedOptions(event.detail.selectedOptions);
    props.onSelectedRolesUpdated(
      new Set(
        event.detail.selectedOptions.map((opt) => UserRoles[opt.value as keyof typeof UserRoles]),
      ),
    );
  };

  const headerInfo = (
    <Box color="text-body-secondary" fontSize="body-s" display="inline">
      {constants.USER_PERMISSION_MGMT_USER_ROLES_INFO}
    </Box>
  );

  return (
    <>
      <Header variant="h3" info={headerInfo}>
        {constants.USER_PERMISSION_MGMT_USER_ROLES_HEADER}
      </Header>
      <FormField
        label={constants.USER_PERMISSION_MGMT_USER_ROLES_LABEL}
        description={constants.USER_PERMISSION_MGMT_USER_ROLES_DESC}
      >
        <Multiselect
          options={options}
          selectedOptions={selectedOptions}
          onChange={handleSelectionChange}
          deselectAriaLabel={() => 'Remove role'}
          ariaRequired
        />
      </FormField>
    </>
  );
}
